"use client";

import { useVersionCheck } from "@/hooks/use-version-check";
import { RefreshCw, X } from "lucide-react";

export function VersionCheckProvider({ children }: { children: React.ReactNode }) {
	// Initialize version checking (checks every 5 minutes)
	const { hasUpdate, serverVersion, reloadToUpdate, dismissUpdate } = useVersionCheck(300000);

	return (
		<>
			{children}
			{/* Subtle update banner - fixed at bottom */}
			{hasUpdate && (
				<div className="fixed bottom-4 left-4 z-50 flex items-center gap-3 rounded-lg bg-primary/95 px-4 py-2.5 text-primary-foreground shadow-lg backdrop-blur-sm animate-in slide-in-from-bottom-4 duration-300">
					<span className="text-sm">v{serverVersion} available</span>
					<button
						onClick={reloadToUpdate}
						className="flex items-center gap-1.5 rounded-md bg-primary-foreground/20 px-2.5 py-1 text-xs font-medium transition-colors hover:bg-primary-foreground/30"
					>
						<RefreshCw className="h-3 w-3" />
						Refresh
					</button>
					<button
						onClick={dismissUpdate}
						className="rounded p-0.5 transition-colors hover:bg-primary-foreground/20"
						aria-label="Dismiss"
					>
						<X className="h-4 w-4" />
					</button>
				</div>
			)}
		</>
	);
}
